import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import integrationsTranslations from 'i2l?query=sporks!../../../lang/integrations/en.lyaml';
import { useScopedTranslations } from 'pricing-pages-ui-components/i18n/useScopedTranslations';
import { PageSection, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { useContext, useMemo } from 'react';
import { PublicI18nContext } from '../../context/I18nContext';
import { useTrackSectionViewed } from '../../hooks/useTrackSectionViewed';
import { TRACKING_SOURCES } from '../../utils/tracking';
import { getPublicIntegrations } from './Integrations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicIntegrationsSection = ({
  productGroup,
  screen
}) => {
  const {
    i18nLoader
  } = useContext(PublicI18nContext);
  const T = useScopedTranslations(integrationsTranslations, i18nLoader);
  const integrations = useMemo(() => getPublicIntegrations(productGroup), [productGroup]);
  const sectionRef = useTrackSectionViewed(TRACKING_SOURCES.INTEGRATIONS, screen);
  return /*#__PURE__*/_jsx("div", {
    ref: sectionRef,
    children: /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CardWrapper, {
        marginBlock: "0",
        paddingBlock: "1300",
        children: /*#__PURE__*/_jsxs(CardSection, {
          padding: "0",
          children: [/*#__PURE__*/_jsx(T.Skeleton, {
            widths: ['60%', '90%'],
            heights: [32, 16],
            children: /*#__PURE__*/_jsxs(SectionHeader, {
              children: [/*#__PURE__*/_jsx(SectionTitle, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "integrations.title"
                })
              }), /*#__PURE__*/_jsx(SectionSubTitle, {
                children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: "integrations.subtitle",
                  options: {
                    count: /*#__PURE__*/_jsx(FormattedNumber, {
                      value: 2000
                    })
                  }
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Flex, {
            flexWrap: "wrap",
            alignItems: "stretch",
            justifyContent: "center",
            children: integrations.map(({
              appName,
              logo
            }) => /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              maxInlineSize: "104px",
              inlineSize: "100%",
              blockSize: "100%",
              children: [/*#__PURE__*/_jsx(Image, {
                src: logo,
                blockSize: "48px",
                inlineSize: "48px",
                margin: "400",
                alt: appName
              }), /*#__PURE__*/_jsx(Text, {
                textAlign: "center",
                children: appName
              })]
            }, appName))
          })]
        })
      })
    })
  });
};